// extracted by mini-css-extract-plugin
module.exports = {"overlay":"cookie-consent_overlay__9fR9P"};